export default [
    {
        path: '/dynamic-time',
        name: 'dynamict-time',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Horário',
            icon: 'mdi-puzzle-outline',
            breadcrumbs: [
                { text: 'Alocação dinâmica', disabled: true, href: '/' },
                { text: 'Horário', disabled: true, href: '/' },
            ],
        }
    },
    {
        path: '/dynamic-time-results',
        name: 'dynamic-time-results',
        component: () => import ('./pages/Result'),
        meta: {
            title: 'Resultados',
            icon: 'mdi-puzzle-outline',
        }
    }
]